import { render, staticRenderFns } from "./lpBox.vue?vue&type=template&id=53d7d3ca&scoped=true"
import script from "./lpBox.vue?vue&type=script&lang=js"
export * from "./lpBox.vue?vue&type=script&lang=js"
import style0 from "./lpBox.vue?vue&type=style&index=0&id=53d7d3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d7d3ca",
  null
  
)

export default component.exports